import { gql } from '@apollo/client';

export const GET_TITLE_BY_EDITOR_ID = gql`
  query titlesAsEditor(
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $searchText: String
    $status: Int
    $byPublishPost: Boolean
  ) {
    titlesAsEditor(
      filter: {
        limit: $limit
        offset: $offset
        dateStart: $dateStart
        dateEnd: $dateEnd
        searchText: $searchText
        status: $status
        byPublishPost: $byPublishPost
      }
    ) {
      titles {
        id
        title
        writerId
        status
        comments
        createdAt
        researchLinks
        suggestedKeywords
        countries
        status
        postUrl
        publishPost
        language
        deadline
      }
      permissions {
        hasWorking
        statusCanBeOpened
        showAddTitle
        showPagination
        showWriters
        showStatus
        showBackDate
        showPublishNow
        showCountries
        showAddCategories
        statusToRejectReason
        reasonToOtherReason
        showSitesFilter
        showWritersFilter
        validations
      }
      total
    }
  }
`;
